module.exports = __webpack_public_path__ + "static/media/Cam.00fce510.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Cam/Cam.mp4
// module id = 117
// module chunks = 0